import React, { useEffect, useRef, useState, useContext } from "react";

import { useLocation, useNavigate } from "react-router-dom";
const LandingHeader = () => {
  const [config, setConfig] = useState({});
  const location = useLocation();
  const navigate = useNavigate();

  let img = window.app.img;
  useEffect(() => {
    if (window.site) {
      setConfig(window.site);

    }

  }, [window.site]);



  if (config.common && config.common.imagesCDN) {
    img = config.common.imagesCDN;
  }
   const handleBack = (e) => {
    navigate("/");
  }
  return (
    <nav className="navbar navbar-expand-lg nav-bar-wrapper">
      <div className="container-fluid pt-3">
        {/* Logo */}
        <a className="navbar-brand" onClick={handleBack}>
          <img
            src={`${img}orasi/client/resources/orasiv1/images/logo_white.png`}
            alt="Logo"
          />
        </a>

        {/* Mobile Menu Button */}
        <button
          className="navbar-toggler text-white"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu Links */}
        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav" id="navbar-nav">
            <li className="nav-item" id="nav-item-home">
              <a
                id="nav-link-home"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/");
                }}
                className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
              >
                Home
              </a>
            </li>

            <li className="nav-item" id="nav-item-productionhub">
              <a
                id="nav-link-productionhub"
                onClick={() => navigate("/productioncircle")}
                className={`nav-link ${location.pathname === "/productioncircle" ? "active" : ""}`}
              >
                Production circle
              </a>
            </li>

            <li className="nav-item" id="nav-item-marketplace">
              <a
                id="nav-link-marketplace"
                onClick={() => navigate("/marketplace")}
                className={`nav-link ${location.pathname === "/marketplace" ? "active" : ""}`}
              >
                Marketplace
              </a>
            </li>

            <li className="nav-item" id="nav-item-aidubbing">
              <a
                id="nav-link-aidubbing"
                onClick={() => navigate("/aidubbing")}
                className={`nav-link ${location.pathname === "/aidubbing" ? "active" : ""}`}
              >
                AI Dubbing / Subtitling
              </a>
            </li>

            <li className="nav-item" id="nav-item-ailicensing">
              <a
                id="nav-link-ailicensing"
                onClick={() => navigate("/ailicensing")}
                className={`nav-link ${location.pathname === "/ailicensing" ? "active" : ""}`}
              >
                AI Licensing
              </a>
            </li>

            <li className="nav-item" id="nav-item-about">
              <a
                id="nav-link-about"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/aboutus");
                }}
                className={`nav-link ${location.pathname === "/aboutus" ? "active" : ""}`}
              >
                About us
              </a>
            </li>

            <li className="nav-item" id="nav-item-blog">
              <a
                id="nav-link-blog"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/blog");
                }}
                className={`nav-link ${location.pathname === "/blog" ? "active" : ""}`}
              >
                Blog
              </a>
            </li>

            {/* Sign In Dropdown */}
            <li className="nav-item dropdown sign-button" id="nav-signin">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                id="nav-link-signin"
              >
                Sign In
              </a>
              <ul className="dropdown-menu" id="dropdown-menu-signin">
                <li id="signin-marketplace-item">
                  <a
                    id="signin-marketplace-link"
                    className="dropdown-item"
                    onClick={() => navigate("/login")}
                    style={{ cursor: "pointer" }}
                  >
                    {/* <span className="material-symbols-outlined">arrow_forward_ios</span> */}
                    <img
                      src={`${img}orasi/client/resources/orasiv1/images/sign-in-arrow.svg`}

                    />
                    Marketplace
                  </a>
                </li>
                <li id="signin-productionhub-item">
                  <a
                    id="signin-productionhub-link"
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    href="http://app.orasimedia.com/sign-in"
                    target="_blank"
                  >
                    {/* <span className="material-symbols-outlined">arrow_forward_ios</span> */}
                     <img
                      src={`${img}orasi/client/resources/orasiv1/images/sign-in-arrow.svg`}

                    />
                    Production circle
                  </a>
                </li>
              </ul>
            </li>

            {/* Sign Up Dropdown */}
            <li className="nav-item dropdown sign-button" id="nav-signup">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                data-bs-display="static"
                aria-expanded="false"
                id="nav-link-signup"
              >
                Sign Up
              </a>
              <ul className="dropdown-menu dropdown-menu-end" id="dropdown-menu-signup">
                <li id="signup-marketplace-item">
                  <a
                    id="signup-marketplace-link"
                    className="dropdown-item"
                    onClick={() => navigate("/signup")}
                    style={{ cursor: "pointer" }}
                  >
                    {/* <span className="material-symbols-outlined">arrow_forward_ios</span> */}
                     <img
                      src={`${img}orasi/client/resources/orasiv1/images/sign-in-arrow.svg`}

                    />
                    Marketplace
                  </a>
                </li>
                <li id="signup-productionhub-item">
                  <a
                    id="signup-productionhub-link"
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    href="http://app.orasimedia.com/checkout"
                    target="_blank"
                  >
                    {/* <span className="material-symbols-outlined">arrow_forward_ios</span> */}
                     <img
                      src={`${img}orasi/client/resources/orasiv1/images/sign-in-arrow.svg`}

                    />
                    Production Circle
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>

      </div>
    </nav>

  );
};

export default LandingHeader;
